// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ChevronRight } from 'lucide-react'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Link } from 'react-router'
 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { cn } from '#app/utils/misc.tsx'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Button } from './ui/button.tsx'

interface BreadcrumbItem {
  label: string
  href?: string
}

interface PageHeaderProps {
  title: string
  subtitle?: string
  breadcrumbs?: BreadcrumbItem[]
  actions?: React.ReactNode
}

export function PageHeader({ title, subtitle, breadcrumbs = [], actions }: PageHeaderProps) {
  // Get the title from breadcrumbs if available, otherwise use title prop
  const displayTitle = breadcrumbs.length > 0 
    ? breadcrumbs[breadcrumbs.length - 1]?.label || title
    : title

  return (
    <header className={cn("flex items-center justify-between border-b bg-background px-6 flex-shrink-0", subtitle ? "h-20" : "h-14")}>
      <div>
        <h1 className="text-xl font-bold font-[family-name:var(--font-heading)]">
          {displayTitle}
        </h1>
        {subtitle && (
          <p className="text-sm text-muted-foreground">{subtitle}</p>
        )}
      </div>
      
      {/* Actions */}
      {actions && (
        <div className="flex items-center gap-2">
          {actions}
        </div>
      )}
    </header>
  )
}